import { UseQueryOptions } from 'react-query';
import { useUserByProfileId } from './useUserByProfileId';
import { useProfileIdByChatId } from './useProfileIdByChatId';

type UseUserByChatId = {
    eventId: number;
    chatId: string | number | null;
    options?: UseQueryOptions;
};

export const useUserByChatId = ({ eventId, chatId, options }: UseUserByChatId) => {
    const { data: userProfileId } = useProfileIdByChatId({ eventId, chatId, options });

    return useUserByProfileId({
        eventId,
        userProfileId,
        options: { enabled: !!userProfileId, staleTime: Infinity, cacheTime: 500 },
    });
};
